var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300.48 157.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #000;\n        font-family: FranklinGothic-Medium, 'Franklin Gothic Medium';\n        font-size: 48px;\n        font-weight: 500;\n      }\n\n      .cls-2 {\n        letter-spacing: 0em;\n      }\n\n      .cls-3 {\n        fill: #6ba1d3;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M29.19,72.48c2.56,6.09,8.63,8.74,12.79,13.01,17.03,17.48,16.63,39.89-1.54,55.99-5.31,4.7-11.15,8.82-16.78,13.16-2.47,1.9-5.44,4.42-8,.9-2.26-3.11.08-5.78,2.75-7.78,10.8-8.08,7.73-11.24-4.08-11.53-2.73-.07-5.71-1.02-5.78-4.27-.1-4.21,3.48-4.62,6.63-4.71,6.24-.18,12.49,0,18.73-.19,3.4-.11,8.03.6,8.17-4.44.16-5.48-4.48-5.82-8.6-5.88-8.03-.11-16.06.06-24.08-.13-3.75-.09-9.57,1.1-9.27-4.49.27-5.19,6.01-4.03,9.84-4.1,8.03-.16,16.06,0,24.08-.13,3.6-.06,7.68-.25,7.71-5.17.04-4.98-4.03-5.11-7.65-5.18-6.69-.12-13.38-.08-20.07-.12-2.83-.02-5.79-.63-6.26-3.69-.66-4.28,2.89-4.64,6.06-5.24,3.61-.68,9.22,1.73,10.11-3.5.74-4.31-4.76-5.84-7.61-8.42C-11.09,51.67-2.8,12.14,32.32.49c2.48-.82,4.54-.75,5.84,1.31,1.81,2.86,0,5.1-2.25,6.75-12.54,9.17-9.84,13.27,4.52,13.84,2.59.1,5.8.6,5.79,4.1,0,4.14-3.33,4.68-6.62,4.71-6.69.06-13.38,0-20.07.09-3.95.05-9.09-.53-9.29,4.91-.21,5.51,4.89,5.3,8.87,5.33,11.6.09,23.19.02,34.79.1,3.52.02,7.99-.19,7.59,4.86-.31,3.98-4.42,3.71-7.49,3.73-11.15.1-22.3.02-33.45.13-4.06.04-8.86.09-8.57,5.74.24,4.76,4.7,4.53,8.22,4.61,5.8.13,11.6.01,17.39.1,3.52.05,8.07-.34,8.56,4.19.55,5.14-4.44,4.41-7.7,4.98-2.93.51-6.18-.33-9.26,2.54Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(79.79 62.87)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2",
    x: 28.76,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 44.39,
    y: 0
  }, "ostatype"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 57.6
  }, "Genomics"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.513d79185559ab299720ce65bdfc7610.svg";
export { ForwardRef as ReactComponent };